<template>
	<div>
		<el-dialog title="业务流程设置" :visible.sync="dialogShow" :close-on-click-modal="false" :destroy-on-close="true"
			width="1200px" @close="closeDialog">

			<el-tabs v-model="activeName">
				<el-tab-pane label="配置项" name="config"></el-tab-pane>
				<el-tab-pane label="学生审批流程" name="shenpi"></el-tab-pane>

			</el-tabs>


			<div v-show="activeName == 'config'">

				<div style="text-align: right;">


					<el-button type="infor" size="small" @click="addNew()">添加配置项</el-button>

				</div>

				<div style="font-size: 12px; padding: 20px;">
					<span style="color: orangered; font-weight: bolder;">【logo】</span>方形图标（1:1）；
					<span style="color: orangered; font-weight: bolder;">【leftlogo】</span>首页左上角图标（200x50）；
					<span style="color: orangered; font-weight: bolder;">【schoolname】</span>学校名称；
					<span style="color: orangered; font-weight: bolder;">【loginbg】</span>登录页背景图；
					<span style="color: orangered; font-weight: bolder;">【mainbg】</span>首页背景图；
					<span style="color: orangered; font-weight: bolder;">【favico】</span>浏览器tab页小图标；
					<span style="color: orangered; font-weight: bolder;">【appname】</span>小程序名称；
					<span style="color: orangered; font-weight: bolder;">【data_exprise】</span>数据可查看有效期


				</div>
				<el-form :model="formData" ref="ruleForm" label-width="80px">
					<el-row v-for="(item, idx) in DataList" :key="idx">
						<el-col :span="6">
							<el-form-item label="参数名称" prop="role_name">
								<el-input v-model.trim="item.remark" style="width: 100%" />
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="参数代码" prop="role_name">
								<el-input v-model.trim="item.ktype" style="width: 100%" />
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="参数值" prop="role_name">
								<el-input type="textarea" :rows="2" v-model.trim="item.kvalue" style="width: 100%" />
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item>

								<el-upload style="display: inline-block; margin-right: 20px;" action=""
									:http-request="uploadOss" :on-success="uploadFiles" :show-file-list="false"
									name="image">
									<el-button title="传图" size="small" type="primary"
										icon="el-icon-picture-outline-round" @click="setRowIndx(idx)" circle="">
									</el-button>
								</el-upload>


								<el-button size="small" type="primary" icon="el-icon-s-claim" @click="saveData(item)">保存
								</el-button>

							</el-form-item>
						</el-col>
					</el-row>

				</el-form>
			</div>

			<div v-show="activeName == 'shenpi'">
				<div style="text-align: right;">
					请先选择流程再添加：
					<el-select v-model="processStatus" size="small">
						<el-option label="请选择流程" value=""></el-option>
						<el-option v-for="(item, idx) in processData" :key="idx" :label="item.title"
							:value="item.pcode">
						</el-option>

					</el-select>
					<el-button type="infor" icon="el-icon-plus" size="small" @click="addProcess()">添加流程项</el-button>
				</div>


				<el-card shadow="never" v-for="(process, idx) in processList" :key="idx" style="margin-bottom:2px">
					<div v-for="(p, i) in processData" :key="i" v-if="p.pcode == process.pcode">
						<span style="color:orangered;font-size: 18px;">{{ p.title }}</span> <span style="color:blue">{{
								p.desc
						}}</span>
					</div>
					<div style="padding-top:20px">
						操作后进入哪一个状态：<el-select v-model="process.status" size="small">
							<el-option label="请选择步骤" value=""></el-option>
							<el-option label="待审核" :value="0"></el-option>
							<el-option label="已审核待缴费" :value="1"></el-option>
							<el-option label="已缴费待录取" :value="2"></el-option>
							<el-option label="已录取待分班" :value="3"></el-option>

						</el-select>

					</div>
					<div style="padding-top:20px">
						页面显示数据列
						<div style="padding-top:10px">
							<el-tag size="small" @click="showColumnsDialog" style="cursor:pointer"><i
									class="el-icon-plus"></i></el-tag>
						</div>
					</div>
					<div style="padding-top:20px">
						操作列显示的按钮：

					</div>
				</el-card>





			</div>
		</el-dialog>


		<el-dialog title="显示列设置" :visible.sync="columnShow" :close-on-click-modal="false" width="800px">
				<el-card shadow="never">
					所有可用列：请按顺序添加
					<div>
						<el-tag v-for="(item,idx) in AllColumns" :key="idx" size="small" type="info"  effect="plain" @click="showColumnsDialog" style="cursor:pointer">{{item.label}}</el-tag>
					</div>
				</el-card>
		</el-dialog>

	</div>
</template>

<script>
import col from "./busConfigColumns"
export default {
	data() {
		return {
			formData: {},
			dialogShow: true,
			DataList: [],
			activeName: "shenpi",
			firstRow: {
				id: 0,
				pmid: 0,
				ktype: "",
				kvalue: "",
				remark: ""

			},
			rowidx: -1,
			processData: [
				{ title: "学校导入学生审批流程", desc: "【关联菜单：新生录入、新生审核】学校导入【五年制高职/本地报名表/招办数据】时，导入后的数据显示情况", pcode: "import" },
				{ title: "学生自主报名审批流程", desc: "", pcode: "baoming" },
				{ title: "教师主动录入审批流程", desc: "", pcode: "bulu" },
				{ title: "审核确认步骤审批流程", desc: "", pcode: "step1" },
				{ title: "缴费确认步骤审批流程", desc: "", pcode: "step2" },
				{ title: "录取确认步骤审批流程", desc: "", pcode: "step3" },
				{ title: "外市主动录入审批流程", desc: "", pcode: "outcity" },
				{ title: "协议主动录入审批流程", desc: "", pcode: "xieyi_in" },
				{ title: "协议审核通过审批流程", desc: "", pcode: "xieyi_sp" },
			],


			processStatus: "",
			processItem: {
				id: 0,
				pcode: "",
				title: "",
				status: "",
				stu_type: "",
				ctype: "",
				columns: [],
				buttons: [],
				next_status: 0,
				back_status: 0,
			},
			processList: [],
			columnShow: false,
			AllColumns:col.columns
		}
	},
	mounted() {
		this.getList()
	},

	methods: {

		getList() {
			this.$http.post("/api/sys_platform_config_list", {
				pagesize: 500
			}).then(res => {
				this.DataList = res.data.data
			})
		},


		closeDialog() {
			this.$$parent(this, "busConfigShow", false)
		},
		addNew() {
			this.DataList.push({ ...(this.firstRow) })
		},
		setRowIndx(idx) {
			this.rowidx = idx
		},
		uploadFiles(e) {
			console.log(e)
			console.log(this.rowidx)
			this.DataList[this.rowidx].kvalue = e.src
		},
		saveData(item) {
			item.pm_id = this.$store.state.pmid;
			this.$http.post("/api/sys_platform_config_edit", item).then(ok => {
				this.$message.success('保存成功')

				this.getList()
			})
		},
		addProcess() {
			for (let item of this.processList) {
				if (item.pcode == this.processStatus) {
					this.$message.error('已经添加了该流程，请勿重复添加')
					return
				}
			}
			this.processItem.pcode = this.processStatus;
			let pro = JSON.parse(JSON.stringify(this.processItem))
			this.processList.push(pro)
			this.processStatus = "";

		}, showColumnsDialog(idx) {
			this.columnShow = true
		}
	}
}
</script>

<style>
</style>
